export default __webpack_public_path__ + "static/media/Testimonial.bc1379ec.png";